export default __webpack_public_path__ + "static/media/settings.b294dcd3.svg";